import marketingSideEffects from '../../side-effects/location-settings/marketing/marketing-side-effects'

export function cleanMarketing (settingsBlob) {
  if (settingsBlob.marketing) {
    marketingSideEffects.applySideEffects(settingsBlob.marketing)
  }
}
